import { call, all, takeLatest, put } from "redux-saga/effects";
import createFetchFunction from "../utils/create-fetch-func";
import createFetchSagaPattern from "../fetch/fetch-saga-pattern-creator";
import getFetchInstance from "./../utils/fetch";
import getDataFromResponse from "../utils/get-data-from-res";
import { IInsertImagesPayload, fetchImages } from "./images.action";

function* insertImagesAsync({
    payload: { data },
}: {
    payload: IInsertImagesPayload;
}) {
    let res = yield getFetchInstance().post("questionquiz/uploadimg", data);
    const images = getDataFromResponse(res).images;
    yield put(
        fetchImages({
            images,
        })
    );
}

function* watchInsertImages() {
    yield takeLatest(
        createFetchSagaPattern("INSERT_IMAGES"),
        createFetchFunction("INSERT_IMAGES", insertImagesAsync)
    );
}
export default function* quizSagas() {
    yield all([call(watchInsertImages)]);
}
